import styled from 'styled-components';
import Card from '@components/common/Card';

export const Wrapper = styled.div`
  padding: 105px 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  position: relative;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    padding: 80px 0 60px 0;
    grid-template-columns: repeat(2, 1fr);
    gap: 0 28px;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const Feature = styled(Card)`
  padding: 48px 32px 0;
  height: 377px;
  img {
    margin-bottom: 40px;
  }
  h4 {
    padding-bottom: 1.6rem;
  }
  p {
    color: ${({ theme }) => theme.colors.functional.darkGray};
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    padding: 32px;
    height: 337px;
  }
`;
